import { dateFormatter, dateInput } from '../utils/formaters';
const fileDtoToFile = (file) => {
    return {
        src: file.azureUrl,
        id: file.idInterno,
        name: file.nome,
    };
};
const handleStatus = (dataInicial, dataFinal) => {
    const now = new Date();
    const startOfDay = new Date(dataInicial);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(dataFinal);
    endOfDay.setHours(23, 59, 59, 999);
    if (now < startOfDay) {
        return 'Agendado';
    }
    else if (now >= startOfDay && now <= endOfDay) {
        return 'Em andamento';
    }
    else {
        return 'Encerrado';
    }
};
const handleColorScheme = (cat) => {
    const tagKey = cat.cor.split('.')[1];
    return {
        title: cat.titulo,
        color: `tag.${tagKey || 400}`,
        bg: `tagBg.${tagKey || 400}`,
        id: cat.idInterno,
    };
};
export const communiqueListItemDtoToCommunicationListItem = (dto) => {
    const { coverImage, files, redirectFile } = dto.anexos.reduce((acc, file) => {
        const mappedFile = fileDtoToFile(file);
        switch (file.tipo) {
            case 0:
                acc.coverImage.push(mappedFile);
                break;
            case 1:
                acc.files.push(mappedFile);
                break;
            case 2:
                acc.redirectFile.push(mappedFile);
                break;
            default:
                break;
        }
        return acc;
    }, { coverImage: [], files: [], redirectFile: [] });
    return {
        id: dto.idInterno,
        title: dto.titulo || '-',
        description: dto.descricao || '-',
        bases: dto.grupos.flatMap(grupo => grupo.grupoId),
        category: handleColorScheme(dto.categoria),
        coverImage: coverImage?.[0] || null,
        attachments: files,
        redirectAttachment: redirectFile?.[0],
        redirect: dto.redirecionar,
        startDate: dateInput(String(dto.dataInicial)),
        endDate: dateInput(String(dto.dataFinal)),
        lifetime: dto.vitalicio,
        feedbackEmail: dto.emailFeedback || '-',
        allGroups: dto.gruposAll,
        link: dto.link,
    };
};
export const multipleDtoToNormal = (items) => {
    return items.map(dto => ({
        id: dto.idInterno,
        title: dto.titulo,
        cat: handleColorScheme(dto.categoria),
        period: `${dateFormatter(String(dto.dataInicial))} ${'  ~  '}   ${dto.vitalicio ? 'vitalício' : dateFormatter(String(dto.dataFinal))}`,
        status: handleStatus(dto.dataInicial, dto.dataFinal),
    }));
};
export const communiqueListDtoToCommunicationList = (tableData) => ({
    itens: multipleDtoToNormal(tableData.listagem),
    pageCount: tableData.totalPaginas,
    rows: tableData.totalRegistros,
});
export const ComuniqueCatDtoToComuniqueCat = (items) => items.map(item => handleColorScheme(item));
export const comuniqueBaseMapper = (item) => {
    return item.map(dto => communiqueListItemDtoToCommunicationListItem(dto));
};
